import { EvaStorage } from '@springtree/eva-sdk-core-storage';
/**
 * Helper method for safely parsing JSON strings from storage
 *
 * @template T
 * @param {string} val
 * @param {T} [defaultValue]
 * @returns {(T|undefined)}
 */
export const safeParseInt = (val, defaultValue) => {
    const resultValue = parseInt(val, 10);
    if (isNaN(resultValue)) {
        return defaultValue;
    }
    return resultValue;
};
/**
 * Helper method for safely parsing JSON strings from storage
 *
 * @template T
 * @param {string} val
 * @param {T} [defaultValue]
 * @returns {(T|undefined)}
 */
export const safeParseJson = (val, defaultValue) => {
    try {
        const resultValue = JSON.parse(val);
        return resultValue;
    }
    catch (jsonParseError) {
        return defaultValue;
    }
};
const storage = new EvaStorage();
export default storage;
//# sourceMappingURL=storage.js.map